import { action } from "typesafe-actions";

import { SET_USER } from "./types";

export const setUser = (payload: string | number) => action(SET_USER, payload);
